import { allFromSnapshot, firstFromSnapshot, oneFromSnapshot, } from "@buildwithflux/firestore-compatibility-layer";
import { CommentThreadAnchorType, DocumentCommentContext, messageIsCopilotBlocked, } from "@buildwithflux/models";
export class FirestoreCommentRepository {
    db;
    constructor(db) {
        this.db = db;
    }
    async saveThread(documentUid, thread) {
        await this.db.documentCommentThreadsCollection(documentUid).doc(thread.uid).set(thread);
    }
    async updateThread(documentUid, thread) {
        await this.db.documentCommentThreadsCollection(documentUid).doc(thread.uid).set(thread, { merge: true });
    }
    async setThreadCommentsCount(documentUid, commentThreadUid, count) {
        await this.db.documentCommentThread(documentUid, commentThreadUid).update({
            "data.comment_count": count,
            "data.updated_at": Date.now(),
        });
    }
    /** @inheritDoc */
    async getThreads(documentUid) {
        return allFromSnapshot(await this.db.documentCommentThreadsCollection(documentUid).get());
    }
    /** @inheritdoc */
    async getThread(documentUid, threadUid) {
        return oneFromSnapshot(await this.db.documentCommentThread(documentUid, threadUid).get(), () => undefined);
    }
    /** @inheritdoc */
    async getReplyThread(documentUid, messageUid) {
        return firstFromSnapshot(await this.db
            .documentCommentThreadsCollection(documentUid)
            .where("doc.anchor.reply_to_comment_uid", "==", messageUid)
            .get(), () => undefined);
    }
    /** @inheritdoc */
    async getProjectChatThread(documentUid) {
        // TODO: yes, this is inefficient
        const threads = await this.getThreads(documentUid);
        return threads.find((thread) => thread.anchor.type === CommentThreadAnchorType.document &&
            thread.anchor.context === DocumentCommentContext.projectChat);
    }
    /** @inheritDoc */
    async get(documentUid, commentUid) {
        return oneFromSnapshot(await this.db.documentComment(documentUid, commentUid).get(), () => undefined);
    }
    /** @inheritDoc */
    async getAllForThread(documentUid, threadUid) {
        return allFromSnapshot(await this.db
            .documentCommentsCollection(documentUid)
            .where("data.belongs_to_comment_thread_uid", "==", threadUid)
            .get());
    }
    /** @inheritDoc */
    async save(documentUid, message) {
        await this.db.documentCommentsCollection(documentUid).doc(message.uid).set(message);
    }
    /** @inheritDoc */
    async update(documentUid, message) {
        await this.db.documentCommentsCollection(documentUid).doc(message.uid).set(message, { merge: true });
    }
    /** @inheritDoc */
    async saveLike(documentUid, like) {
        await this.db.documentCommentLike(documentUid, like.belongs_to_comment_uid, like.uid).set(like);
    }
    /** @inheritDoc */
    async getLikes(documentUid, commentUid) {
        return allFromSnapshot(await this.db.documentCommentLikesCollection(documentUid, commentUid).get());
    }
    /** @inheritDoc */
    async setBlockedCommentIsResolved(documentUid, commentUid) {
        const comment = await this.get(documentUid, commentUid);
        if (!comment) {
            throw new Error("Comment not found");
        }
        if (!messageIsCopilotBlocked(comment)) {
            throw new Error("Cannot mark a non-copilot blocked message as resolved");
        }
        await this.db.documentComment(documentUid, commentUid).update({
            "data.copilotMetadata.blockedIsResolved": true,
        });
    }
    /** @inheritDoc */
    subscribeToAllComments(documentUid, onReceive, onDelete, onError) {
        return this.db.documentCommentsCollection(documentUid).onSnapshot((snap) => {
            const addedOrChanged = [];
            const deleted = [];
            // eslint-disable-next-line @buildwithflux/no-array-foreach
            snap.docChanges().forEach((change) => {
                if (change.type === "removed") {
                    deleted.push(change.doc.data());
                }
                else {
                    addedOrChanged.push(change.doc.data());
                }
            });
            onReceive(addedOrChanged);
            onDelete(deleted);
        }, onError);
    }
    /** @inheritDoc */
    subscribeToAllThreads(documentUid, onReceive, onError) {
        return this.db.documentCommentThreadsCollection(documentUid).onSnapshot((snap) => {
            onReceive(snap.docChanges().map((change) => change.doc.data()));
        }, onError);
    }
}
//# sourceMappingURL=FirestoreCommentRepository.js.map